import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
      <section style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
          Upload, view, and share GLB models at the edge
        </h1>
        <p style={{ color: 'var(--muted)', fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto 1.5rem' }}>
          Drag & drop your GLB/glTF files, preview them in the browser, and share
          them with a single link.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          <Link to="/upload">
            <button>Upload Model</button>
          </Link>
          <Link to="/generate">
            <button style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid #475569' }}>
              Generate 3D
            </button>
          </Link>
        </div>
      </section>

      <section
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '1.5rem',
        }}
      >
        {[
          { step: '1', title: 'Upload', desc: 'Drag & drop GLB/glTF files into your library.' },
          { step: '2', title: 'Generate', desc: 'Create 3D assets from text prompts or images.' },
          { step: '3', title: 'Share', desc: 'Get a public link and embed the viewer anywhere.' },
        ].map((item) => (
          <div key={item.step} className="card" style={{ textAlign: 'center' }}>
            <div
              style={{
                width: '2.5rem',
                height: '2.5rem',
                borderRadius: '50%',
                background: 'var(--accent)',
                color: '#0f172a',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                margin: '0 auto 0.75rem',
              }}
            >
              {item.step}
            </div>
            <h3 style={{ margin: '0 0 0.5rem' }}>{item.title}</h3>
            <p style={{ margin: 0, color: 'var(--muted)' }}>{item.desc}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
